import { InputContainer } from "./form/form.module";
import { InputLabelContainer } from "./form/label/containers/input-label.container";


export const FulfillmentOrderStatusComponents = ({
    cancelreason,
    onFulfillmentFormChange,
  dataId,
  fulfillmentOrderStatus
}:any) => {
  return (
    <>
 
          <>
            <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-2">
             <div>
             <InputLabelContainer
                      label="Product Item"
                  />
                  {dataId?.ItemName}
             </div>
             <div>
             <InputLabelContainer
                      label="Items Quantity"
                  />
                 {dataId?.Quantity}
             </div>
             <div>
             <InputContainer
                      label="Cancelled Items"
                      name="CancelledItem"
                      onValueChange={(event: any, _newValue: any) => {
                        onFulfillmentFormChange({
                          fieldValue: event.target.value,
                          field: 'CancelledItem'
                        });
                      }}
                      type="number"
                      value={fulfillmentOrderStatus?.CancelledItem}
                  />
             </div>
              <InputContainer
                label="Cancel Name"
                labelField="Reason"
                list={cancelreason}
                onValueChange={(event: any, newValue: any) => {
                    onFulfillmentFormChange({
                        fieldValue: event.target.value,
                        field: 'Code'
                      });
                }}
                optionName="Choose Reason"
                type="select"
                value={fulfillmentOrderStatus?.Code}
                valueField="Code"
              />
           
            </div>
          </>
      
  
    </>
  );
};
